//src/learn/LearnNotFound.tsx


import React from 'react';

export default function LearnNotFound() {
  return (
    <div className="rounded-3xl bg-white/70 dark:bg-white/10 p-6 shadow-[0_10px_0_rgba(0,0,0,0.08)]">
      <div className="text-xl font-extrabold mb-2">Page not found</div>
      <div className="opacity-90 mb-4">
        This guide doesn’t exist yet (or the link is wrong).
      </div>
      <button
        onClick={() => (window.location.href = '/learn')}
        className="rounded-2xl bg-white/80 dark:bg-white/15 px-4 py-2 font-semibold shadow-[0_8px_0_rgba(0,0,0,0.08)] hover:opacity-95"
      >
        Back to Learn hub
      </button>
    </div>
  );
}
